import cx from 'classnames'
import Button from 'components/Button'
import ModalDialog from 'components/ModalDialog'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button as ChakraButton
} from '@chakra-ui/react'
import {
  DARK_PAGE_BG,
  DARK_TABLE_BORDER,
  DARK_TEXT_PRIMARY,
  DARK_TEXT_MUTED,
  DARK_GREY
} from 'constants/dark-tokens'
import styles from './modalDeleteProcess.module.scss'

interface IModalConfirmProps {
  isOpen: boolean
  toggle: () => void
  onAccept: () => Promise<void>
  onCancel?: () => void
  title: string
  content: string
  confirmAction: string
  isDelete?: boolean
  isLoading?: boolean
  dark?: boolean
}

const ModalConfirm = ({
  isOpen,
  toggle,
  onAccept,
  onCancel,
  title,
  content,
  confirmAction,
  isDelete,
  isLoading = false,
  dark = false
}: IModalConfirmProps) => {
  if (dark) {
    return (
      <Modal isCentered isOpen={isOpen} onClose={toggle}>
        <ModalOverlay bg="rgba(0,0,0,0.6)" />
        <ModalContent
          bg={DARK_PAGE_BG}
          border={`1px solid ${DARK_TABLE_BORDER}`}
          color={DARK_TEXT_PRIMARY}
          borderRadius="12px"
        >
          <ModalHeader
            fontSize="18px"
            fontWeight={700}
            lineHeight="28px"
            color={DARK_TEXT_PRIMARY}
            borderBottom={`1px solid ${DARK_TABLE_BORDER}`}
          >
            {title}
          </ModalHeader>
          <ModalBody py={4} color={DARK_TEXT_MUTED} fontSize="md">
            {content}
          </ModalBody>
          <ModalFooter gap={3}>
            <ChakraButton
              bg="transparent"
              border={`1px solid ${DARK_GREY}`}
              color={DARK_TEXT_MUTED}
              borderRadius="6px"
              fontWeight={500}
              _hover={{ bg: 'rgba(255,255,255,0.06)' }}
              _focus={{ boxShadow: 'none' }}
              isDisabled={isLoading}
              onClick={onCancel ?? toggle}
            >
              Cancel
            </ChakraButton>
            <ChakraButton
              bg="#E53E3E"
              color="white"
              borderRadius="6px"
              fontWeight={500}
              border="none"
              _hover={{ bg: '#C53030' }}
              _focus={{ boxShadow: 'none' }}
              isLoading={isLoading}
              onClick={onAccept}
            >
              {confirmAction}
            </ChakraButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <ModalDialog isOpen={isOpen} headless className={styles.deleteDialog}>
      <h5 className={styles.title}>{title}</h5>
      <p className={styles.deleteTitle}>{content}</p>
      <div className={styles.actionButtons}>
        <Button outline onClick={onCancel ? onCancel : toggle} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          className={cx({ [styles.deleteButton]: isDelete, [styles.primaryColor]: !isDelete })}
          color="danger"
          onClick={onAccept}
          disabled={isLoading}
          isLoading={isLoading}
        >
          {confirmAction}
        </Button>
      </div>
    </ModalDialog>
  )
}

export default ModalConfirm
